import { useWatch, useFormContext } from 'react-hook-form';
import { EpStepContent } from '../../../../../components/HookFormComponents/components/EpStepContent';
import NoIdToggle from '../../../../../components/HookFormComponents/Inputs/NoIdToggle';
import NotificationRefersToIdInput from '../../../../../components/HookFormComponents/Inputs/NotificationRefersToIdInput';
import OccupationRadio from '../../../../../components/HookFormComponents/Inputs/OccupationRadio';
import PatientBirthDate from '../../../../../components/HookFormComponents/Inputs/PatientBirthDate';
import PatientGenderId from '../../../../../components/HookFormComponents/Inputs/PatientGenderId';
import PatientIdentificationInput from '../../../../../components/HookFormComponents/Inputs/PatientIdentificationInput';
import PatientNameInput from '../../../../../components/HookFormComponents/Inputs/PatientNameInput';
import NotificationRefersPersonInput from '../../../../../components/HookFormComponents/Inputs/PersonRadio';
import { useTranslation as t } from '../../../../../hooks/useTranslation';
import { globalizationService } from '../../../../../services/globalizationService';
import { useTranslationStore } from '../../../../../stores/useTranslationStore';
import { userService } from '../../../../../services/userService';
import { useHospitalStore } from '../../../../../stores';
import { useEffect, useState } from 'react';

export default function Step1IncidentNotification() {
  const tag = 'PSNotificationID';
  const { setValue } = useFormContext();

  const { translations } = useTranslationStore((state) => state);
  const { translations: translationPSNotificationID } =
    globalizationService.getTranslationsByTag(tag);
  const PersonValue = useWatch({ name: 'person.inputValue' });
  const personType = useWatch({ name: 'personType.inputValue' });
  const noId = useWatch({ name: 'noId' });

  const { hospitalInfo } = useHospitalStore((state) => state);
  const [isIntegratedHospital, setIsIntegratedHospital] = useState(false);

  const { data: monitoredInfo } = userService.getHospitalIntegratedInfo(
    hospitalInfo ? hospitalInfo.HospitalId : '',
    !!hospitalInfo?.HospitalId,
  );

  useEffect(() => {
    setIsIntegratedHospital(monitoredInfo?.integratedHospital);
  }, [monitoredInfo ,hospitalInfo]);

  useEffect(() => {
    if (PersonValue === 'true' && !isIntegratedHospital && personType === '1')
      setValue('noId', true);
  }, [isIntegratedHospital, PersonValue,hospitalInfo, personType]);

  return (
    <EpStepContent.Card title={t(translations['global'], 'Identification')}>
      <NotificationRefersPersonInput
        translations={translationPSNotificationID}
      />

      <OccupationRadio translations={translationPSNotificationID} />

      <NotificationRefersToIdInput translations={translationPSNotificationID} />

      {isIntegratedHospital && (
        <NoIdToggle translations={translationPSNotificationID} />
      )}

      {PersonValue === 'true' && (
        <>
          <PatientIdentificationInput
            translations={translationPSNotificationID}
          />

          <PatientNameInput translations={translationPSNotificationID} />

          {personType === '1' && (
            <>
              <PatientGenderId translations={translationPSNotificationID} />
              <PatientBirthDate translations={translationPSNotificationID} />
            </>
          )}

          {personType === '2' && (
            <>
              <PatientGenderId translations={translationPSNotificationID} />
              <PatientBirthDate translations={translationPSNotificationID} />
            </>
          )}

          {personType === '3' && (
            <>
              <PatientGenderId translations={translationPSNotificationID} />
              <PatientBirthDate translations={translationPSNotificationID} />
            </>
          )}
        </>
      )}
    </EpStepContent.Card>
  );
}
